import { auditorPeopleSearchSchema } from '@/components/auditor-center/auditorPeopleSearch'
import { createFileRoute } from '@tanstack/react-router'
import { AuditorPeopleRoutePage } from '@/components/auditor-center/AuditorCyclePages'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people',
)({
  validateSearch: auditorPeopleSearchSchema,
  component: AuditorPeopleRoutePage,
})
